// extracted by mini-css-extract-plugin
export default {"timerContainer":"OTPTimer_timerContainer__ySnNB","timerText":"OTPTimer_timerText__Yrm43","resendText":"OTPTimer_resendText__DEZS8","resendLink":"OTPTimer_resendLink__Miwol"};